import { TablePaginationConfig } from 'antd'
import { useEffect } from 'react'
import { useNavigate } from 'react-router-dom'

import WashingMethodPageHeader from '@/components/pages/WashingMethods/List/PageHeader'
import WashingMethodTable from '@/components/pages/WashingMethods/List/Table'
import { API_DEFAULT_PAGE } from '@/constants/api'
import routes from '@/constants/routes'
import { WashingMethod } from '@/types'

import { useWashingMethods } from './WashingMethod.hooks'

const WashingMethods = () => {
  const navigate = useNavigate()

  const {
    getWashingMethodLoading,
    getWashingMethodsResponse,
    getWashingMethods,
    deleteWashingMethod,
    filterToQuery,
    page,
    pageSize,
    setPage,
  } = useWashingMethods()

  const totalItems = getWashingMethodsResponse?.meta.totalItems || 0

  const handleWashingMethod = async (id: WashingMethod['id']) => {
    await deleteWashingMethod({ id })
    setPage(API_DEFAULT_PAGE)
    getWashingMethods()
  }

  const handleChangePage = (config: TablePaginationConfig) => {
    navigate({
      pathname: routes.washingMethods.path,
      search: filterToQuery({
        page: config.current ?? page,
      }),
    })
  }

  useEffect(() => {
    getWashingMethods()
  }, [getWashingMethods, page])

  return (
    <>
      <WashingMethodPageHeader />
      <WashingMethodTable
        {...{
          dataSource: getWashingMethodsResponse?.items,
          getWashingMethodLoading,
          page,
          pageSize,
          totalItems,
        }}
        onDelete={handleWashingMethod}
        onChange={handleChangePage}
      />
    </>
  )
}

WashingMethods.displayName = 'WashingMethods'
export default WashingMethods
